import secureAxios from "./axios/secureAxios";

/**
 * Uploads an image file to the server.
 * @param {File|Blob} image - The image file or Blob to upload
 * @returns {Promise<{ success: boolean, data: object }>} Response from the server
 */
export async function uploadImage(image) {
  const formData = new FormData();
  formData.append('image', image);
  // The API key is handled by secureAxios, do not add it here
  const { data } = await secureAxios.post('/image-upload/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
}

const imageUploadActions = {
  uploadImage,
};

export default imageUploadActions;
